import api from "./api";
import TokenService from "./token.service";

class AuthService {
  login({ email, password }) {
    return api
      .post("/auth/signin", {
        email,
        password,
      })
      .then((response) => {
        if (response.data.accessToken) {
          TokenService.setUser(response.data);
        }

        return response.data;
      });
  }

  async clearLastSeen(userId) {
    return api.put(`/members/lastseen/clear/${userId}`);
  }

  async logout() {
    // Get refresh token before removing user
    const refreshToken = TokenService.getLocalRefreshToken();
    const user = TokenService.getUser();
    if (refreshToken) {
      try {
        await api.post("/auth/logout", { refreshToken });
      } catch (e) {
        // Ignore errors, proceed to remove user anyway
      }
    }
    // Clear LastSeen on logout
    if (user && user.id) {
      try {
        await this.clearLastSeen(user.id);
      } catch (e) {
        // Ignore errors
      }
    }
    TokenService.removeUser();
  }

  register({ username, email, password }) {
    return api.post("/auth/signup", {
      username,
      email,
      password,
    });
  }
  // verifyUser({ email, token }) {
  //   return api.post("/auth/verifyuser", {
  //     email,
  //     token,
  //   });
  // }

  async refreshAccessToken() {
    const refreshToken = TokenService.getLocalRefreshToken();
    if (!refreshToken) throw new Error("No refresh token");
    const response = await api.post("/auth/refreshtoken", { refreshToken });
    if (response.data.accessToken) {
      TokenService.updateLocalAccessToken(response.data.accessToken);
    }
    return response.data.accessToken;
  }

  async updateLastSeen(userId) {
    // Call backend endpoint to update LastSeen
    return api.put(`/members/lastseen/${userId}`);
  }
}

export default new AuthService();
